import React, { useState, useEffect } from "react";

const LenderLogo = ({ offer }) => {
  const [imageFailed, setImageFailed] = useState(false);
  if (!offer.logoUrl || imageFailed) {
    return <span className="font-extrabold text-gray-800 text-[16px] italic">{offer.name}</span>;
  }
  return (
    <img 
      src={offer.logoUrl} 
      alt={offer.name} 
      className="h-full w-auto max-w-[150px] object-contain object-left"
      onError={() => setImageFailed(true)} 
    />
  );
};

const LoanOfferSelection = ({ setCurrentStep, selectedOffer, setSelectedOffer }) => {
  const offers = [
    {
      id: "lnt",
      name: "L&T Finance",
      newEmi: "14,200",
      tenure: 60,
      interestRate: "8.35",
      monthlySavings: 6800,
      logoUrl: process.env.PUBLIC_URL + "/assets/img/image 54.svg" 
    },
    {
      id: "abc",
      name: "Aditya Birla Capital",
      newEmi: "15,600",
      tenure: 60,
      interestRate: "9.25",
      monthlySavings: 5400,
      logoUrl: process.env.PUBLIC_URL + "/assets/img/image 55.svg" 
    }
  ];

  useEffect(() => {
    if (!selectedOffer && offers.length > 0) {
      setSelectedOffer(offers[0]);
    }
  }, [selectedOffer, setSelectedOffer, offers]);

  const handleContinue = () => {
    if (selectedOffer) {
      setCurrentStep(7);
    }
  };

  return (
    <div 
      className="flex flex-col h-[100dvh] w-full max-w-[400px] mx-auto bg-white antialiased text-[#111827]"
      style={{ fontFamily: '"SF Pro", "SF Pro Display", -apple-system, sans-serif' }}
    >
      
      <div className="pt-6 pb-4 px-6 bg-white flex-none">
        <div className="flex items-center justify-between mb-5">
          <button onClick={() => setCurrentStep(5)} className="text-gray-800 focus:outline-none">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M19 12H5M12 19l-7-7 7-7"/>
            </svg>
          </button>
          
          <div className="flex-1 mx-4 flex items-center">
            <div className="h-[7px] flex-1 bg-[#c9f7e0] rounded-full overflow-hidden">
              <div className="h-full bg-[#12F280] w-full"></div>
            </div>
          </div>
          <span className="text-xs text-gray-500 font-medium">5/5</span>
        </div>
        
        <h1 className="text-[24px] font-bold tracking-tight mb-1 flex items-center gap-2">
          Good News! <span className="text-2xl">🎉</span>
        </h1>
        <h2 className="text-[18px] font-bold tracking-tight mb-1">
          Your home loan options are ready
        </h2>
        <p className="text-gray-500 text-[14px]">Choose the one that works best for you.</p>
      </div>

      <div className="px-6 flex-1 overflow-y-auto pb-6">
        <div className="flex flex-col gap-5 pt-2">
          {offers.map((offer) => {
            const isSelected = selectedOffer?.id === offer.id;
            
            return (
              <div 
                key={offer.id}
                onClick={() => setSelectedOffer(offer)}
                className={`p-4 rounded-[20px] border-[1.5px] transition-all cursor-pointer ${
                  isSelected 
                    ? "border-blue-400 bg-white shadow-[0_0_15px_rgba(59,130,246,0.15)]" 
                    : "border-gray-200 bg-white shadow-sm hover:border-gray-300"
                }`}
              >
                <div className="flex items-center justify-start mb-4 h-7">
                  <LenderLogo offer={offer} />
                </div>
                <div className="grid grid-cols-2 gap-2.5">
                  <div className="bg-white rounded-[14px] p-2.5 px-3 border border-gray-100 shadow-sm">
                    <div className="text-[11px] text-gray-400 font-medium mb-1 leading-none">New EMI</div>
                    <div className="text-[14px] font-bold text-gray-900 leading-none tracking-tight whitespace-nowrap">
                      ₹{offer.newEmi} <span className="text-[12px] font-semibold text-gray-500">/mo</span>
                    </div>
                  </div>
                  <div className={`rounded-[14px] p-2.5 px-3 border shadow-sm ${isSelected ? 'border-blue-100 bg-white' : 'border-gray-100 bg-white'}`}>
                    <div className="text-[11px] text-gray-400 font-medium mb-1 leading-none">Tenure</div>
                    <div className="text-[14px] font-bold text-gray-900 leading-none tracking-tight whitespace-nowrap">{offer.tenure} months</div>
                  </div>
                  <div className="bg-white rounded-[14px] p-2.5 px-3 border border-gray-100 shadow-sm">
                    <div className="text-[11px] text-gray-400 font-medium mb-1 leading-none">Interest Rate</div>
                    <div className="text-[14px] font-bold text-gray-900 leading-none tracking-tight whitespace-nowrap">{offer.interestRate}% p.a.</div>
                  </div>
                  <div className="bg-[#f0fdf4] rounded-[14px] p-2.5 px-3 border border-[#bbf7d0] shadow-sm">
                    <div className="text-[11px] text-[#15803d] font-medium mb-1 leading-none">Monthly Savings</div>
                    <div className="text-[14px] font-bold text-[#16a34a] leading-none tracking-tight whitespace-nowrap">Upto ₹{offer.monthlySavings.toLocaleString('en-IN')}</div>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>

      <div className="bg-white border-t border-gray-100 px-5 pt-4 pb-6 flex-none z-10">
        <p className="text-center text-[10px] text-gray-400 mb-4 px-2 leading-relaxed">
          Offers shown are based on the information available at this stage. Final loan amount, interest rate, tenure, top-up eligibility and other terms are subject to lender verification and approval.
        </p>
        <button onClick={handleContinue} className="w-full bg-black text-white font-medium py-4 rounded-xl text-[16px] active:scale-[0.98] transition-transform">
          Continue
        </button>
      </div>
      
    </div>
  );
};

export default LoanOfferSelection;